import styled from "styled-components";
import { GrayColors, SolutionColorVariables } from "@smartsuite/types";

export const StyledWrapper = styled.div<{
  isSelected: boolean;
  isPlaceholder: boolean;
}>`
  display: flex;
  align-items: center;
  min-height: 52px;
  border-radius: 5px;
  padding: 8px 10px;
  cursor: pointer;
  margin: 0 5px;
  transition: background-color 200ms ease-in;

  &:hover {
    background-color: ${GrayColors["G-1"]};
  }

  &:not(:last-child) {
    margin-bottom: 4px;
  }

  ${(props) =>
    props.isSelected &&
    `
    background-color: ${SolutionColorVariables.sc1};

    &:hover {
      background-color: ${SolutionColorVariables.sc1};
    }
  `}

  ${(props) =>
    props.isPlaceholder &&
    `
    min-height: auto;
    padding: 0;
    margin: 0;
    margin-bottom: 0 !important;
    white-space: nowrap;

    &:hover {
      background-color: transparent;
    }

    .update-value-option-title {
      margin-bottom: 0 !important;
      margin-left: -4px;
    }

    .type-icon {
      min-width: 12px !important;
      width: 12px !important;
      height: 12px !important;
    }
  `}
`;

export const StyledInner = styled.div`
  padding-left: 10px;
  display: flex;
  flex-direction: column;

  .update-value-option-title {
    margin-bottom: 2px;
  }
`;
